import { ISelectValues } from "../../../component/ISelectValues";

const COLOR_ERROR = 'error';
const COLOR_ACCOUNTED = 'success';

export const ID_FILTER_STATUS = "status";
export const ID_FILTER_DEBTOR_NAME = "debtorName";
export const ID_FILTER_AMOUNT_FROM = "amountFrom";
export const ID_FILTER_AMOUNT_TO = "amountTo";
export const ID_FILTER_REFERENCE = "reference";
export const ID_FILTER_IBAN = "iban";
export const ID_FILTER_SUBSCRIPTION_DATE_FROM = "subscriptionFrom";
export const ID_FILTER_SUBSCRIPTION_DATE_TO = "subscriptionTo";
export const ID_FILTER_MANDATE_ID = "mandateId";

export const STATUSES: ISelectValues[] = [
    {
        value: "ACCOUNTED",
        label: "types.statuses.ACCOUNTED",
        color: COLOR_ACCOUNTED,
    },
    {
        value: "OUTSTANDING",
        label: "types.statuses.OUTSTANDING",
        color: COLOR_ERROR,
    }
];

export const convertTypology = (type: ISelectValues[], value: string) => {
    const item = type.find((item) => item.value === value);
    return item ? item.label : value;
}

export const getCollectionsSummaryFields = () => {
    return [
        "ACCOUNTED",
        "OUTSTANDING"
    ];
}
